import { selector } from 'recoil';
import { allCoverablesAtom } from '../atoms/allCoverablesAtom';
import { loadTerms } from '../../services/hippo.service';
import { topConfigContextAtom } from '../atoms/topConfigContextAtom';

export const hippoTermsDocInfoSelector = selector({
    key: 'hippoTermsDocInfoSelector',
    get: async ({ get }) => {
        const topConfigContext = get(topConfigContextAtom);
        const allCoverables = get(allCoverablesAtom);
        const coverableList = Object.values(allCoverables ?? []).flat(1);
        const requestList: string[] = coverableList
            .map((coverable) => (Array.isArray(coverable.termIds) ? coverable.termIds : []))
            .flat(1);

        return await loadTerms(topConfigContext, [...new Set(requestList)]);
    }
});
